'use client'
import { useSearchParams } from 'next/navigation'
import { z } from 'zod'

const routerQuerySchema = z.object({
  postcode: z.string().min(3).optional(),
  street: z.string().min(3).optional(),
  date: z.string().min(10).optional(),
  time: z.string().min(5).optional(),
})

const useQueryParams = () => {
  const searchParams = useSearchParams()
  const queryObject = {
    postcode: searchParams?.get('postcode') ?? undefined,
    street: searchParams?.get('street') ?? undefined,
    date: searchParams?.get('date') ?? undefined,
    time: searchParams?.get('time') ?? undefined,
  }
  return routerQuerySchema.parse(queryObject)
}
export default useQueryParams
export { routerQuerySchema }
